module.exports = __webpack_public_path__ + "static/media/teacher-01.48377770.png";